/**
 * Text Animation
 */

declare var gsap : any;

const animation = () => {
  
  const tl = gsap.timeline();

  const texts = document.querySelectorAll('.js-hero-animate .js-text') as NodeListOf<HTMLElement>;

  const fades = document.querySelectorAll('.js-fade') as NodeListOf<HTMLElement>;

  tl.from('.lp__hero-section', {
    opacity: 0,
    duration: 0.5,
    delay: 0.5,
  })
  .from(texts, {
    yPercent: 100,
    duration: 0.5,
    stagger: 0.2,
    delay: 0,
    ease: 'power1',
  });

  if (window.innerWidth > 767) {
    tl.from('.js-contact-sticky', {
      xPercent: 103,
      duration: 0.5,
    });
  }

  fades.forEach(item => {
    let fadeDelay = item.getAttribute('data-delay');
    console.log(item.getAttribute('data-delay'));
    gsap.from(item, {
      scrollTrigger: {
        trigger: item,
        start: 'top bottom-=200',
        // markers: true
      },
      y: 50,
      opacity: 0,
      duration: 0.4,
      ease: 'circ',
      delay: fadeDelay,
    });
  });

};

export default animation;
